/* eslint-disable no-console */
export const GetFiatCurrency = async (fiat: string) =>
  fetch(`/api/public/finance/ctf?fiat=${fiat}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
